import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { TextField, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { SecMagasin } from "../../../../models/SecMagasin";
import {
  useDeleteMagasinMutation,
  useUpdateMagasinMutation,
} from "../../../../redux/features/cache";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { addRequestToSend } from "../../../../redux/features/appStateSlice";
import { RequestToSend } from "../../../../models/RequestToSend";

export interface IFormMagasin {
  data: SecMagasin;
}

export default function FormMagasin({ data }: IFormMagasin) {
  const [dirty, setDirty] = useState<boolean>(false);
  const [updateMagasin] = useUpdateMagasinMutation();
  const [deleteMagasin] = useDeleteMagasinMutation();
  const d_inv01rp = useAppSelector((state) => state.appState.d_inv01rp);
  const [value, setValue] = useState<string>(data.nombre_vise.toString());
  const dispatch = useAppDispatch();

  useEffect(() => {
    setDirty(false);
  }, [data]);

  const handleDelete = () => {
    dispatch(
      addRequestToSend(
        new RequestToSend(
          `Supprimer magasin ${data.magasin.mag_nom}`,
          deleteMagasin,
          () => {},
          {},
          {
            plans_seq: data.plans_seq,
            mag_num: data.mag_num,
          },
          []
        )
      )
    );
  };

  const handleSub = () => {
    let form = {
      plans_seq: data.plans_seq,
      nombre_vise: value,
      mag_num: data.mag_num,
    };
    dispatch(
      addRequestToSend(
        new RequestToSend(
          `Modifier magasin ${data.magasin.mag_nom}`,
          updateMagasin,
          () => {},
          {},
          form,
          []
        )
      )
    );
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
      <TextField
        sx={{ m: 1, width: "33%" }}
        disabled
        value={data.magasin.mag_nom}
        label={"Magasin"}
      />
      <TextField
        sx={{
          m: 1,
          width: "33%",
          ".Mui-disabled": { WebkitTextFillColor: "black" },
        }}
        onChange={(e) => {
          setDirty(true);
          setValue(e.target.value);
        }}
        defaultValue={data.nombre_vise}
        label={"Objectif produit sur plancher"}
      />
      <TextField
        sx={{ m: 1, width: "33%" }}
        disabled
        value={data.nombre_reel}
        label={"Qté actuel sur plancher"}
      />
      <Tooltip title="Enregistrer">
        <span
          style={{
            display: "flex",
            alignItems: "center",
            padding: "6px 28px",
            cursor: "pointer",
          }}
          className={`save-wrapper ${!dirty ? "custom-disabled" : ""}`}
        >
          <span
            className={`k-icon k-font-icon k-i-save k-icon-xl`}
            onClick={handleSub}
          ></span>
        </span>
      </Tooltip>
      <Tooltip title="Effacer">
        <span>
          <Button
            color="error"
            disabled={!d_inv01rp.canDelete}
            onClick={handleDelete}
          >
            {" "}
            <DeleteIcon />
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
}
